// export {default} from "./Magazine";
import Magazine from './Magazine';

export default Magazine;